import { CardsBlockImageAspectRatioType } from 'common/builder/blocks/blockConstants'
import { IBlock, ICardsBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { CardImageConverter } from 'common/builder/components/chart/FlowChart/lib/utils/CardImageConverter'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import {
  CardAspectRatio,
  FlowChartCard,
  FlowChartCardsBlock,
} from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'
import { BlockType } from 'common/builder/constants/BlockType'
import { getBlockById } from 'common/builder/selectors/builder/entitySelectors'

export const CardsBlockGenericConverterRule: ConverterRule<
  ICardsBlock,
  FlowChartCardsBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) =>
    entity?.type === BlockType.CARDS || entity?.type === BlockType.LIST,
  convert: (entity: ICardsBlock, { state, fields, builderId, flowChartButtons }) => ({
    id: entity.id,
    type: FlowChartBlockType.CARDS,
    data: {
      cards: entity.blocks.reduce((acc: FlowChartCard[], blockId) => {
        const block = getBlockById(state, builderId, blockId)

        if (block && block.type === BlockType.CARD) {
          acc.push({
            id: block.id,
            title: replaceFieldsInString(block.title, fields),
            subTitle: replaceFieldsInString(block.subtitle, fields),
            isHidden: block.isCardHidden || false,
            url: block.defaultAction?.url || null,
            aspectRatio:
              entity.imageAspectRatio === CardsBlockImageAspectRatioType.SQUARE
                ? CardAspectRatio.SQUARE
                : CardAspectRatio.LANDSCAPE,
            image: CardImageConverter.replaceFieldsInCardImage(
              CardImageConverter.fromIBlockImage(block.image),
              fields,
            ),
            buttons: getButtonsFromMap(block.buttons, flowChartButtons),
          })
        }

        return acc
      }, []),
    },
  }),
}
